import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORPROPOSAL } from "../../../../utils/constants";
import { RFPInterface } from "../../../../models/ProcurementModule/RequestForProposal";

interface UpdateRFPContext {
  previousRFQ: RFPInterface[];
}

interface UpdateDocumentUrlInput {
  id: string;
  documentUrl: string;
}

const useAddDocGenRFP = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateDocumentUrlInput, UpdateRFPContext>({
    // No mutationFn needed if there's no server call
    mutationFn: async () => {
      return; // optional noop
    },

    onMutate: async ({ id, documentUrl }) => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_REQUESTFORPROPOSAL, page, pageSize],
      });

      const previousRFQ =
        queryClient.getQueryData<RFPInterface[]>([
          CACHE_KEY_REQUESTFORPROPOSAL,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<RFPInterface[]>(
        [CACHE_KEY_REQUESTFORPROPOSAL, page, pageSize],
        (data = []) =>
          data.map((item) => (item.id === id ? { ...item, documentUrl } : item))
      );

      return { previousRFQ };
    },

    onError: (_error, _variables, context) => {
      if (!context) return;

      queryClient.setQueryData<RFPInterface[]>(
        [CACHE_KEY_REQUESTFORPROPOSAL, page, pageSize],
        context.previousRFQ
      );
    },
  });
};

export default useAddDocGenRFP;
